import { render, staticRenderFns } from "./UnidadeNegocioModule.vue?vue&type=template&id=7699f222"
import script from "./UnidadeNegocioModule.vue?vue&type=script&lang=js"
export * from "./UnidadeNegocioModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports